module.exports = __webpack_public_path__ + "static/media/MTL_BASE_SL1.c3e71f3b.png";